module.exports = __webpack_public_path__ + "static/media/mag.23be4efb.png";